<div class="custom-modal-layout">
  <div class="modal-header" style="margin-bottom: 5px !important;">
    <div class="icon">
      <img src="icons/plus-circle.svg" alt="Email Icon" />
    </div>
    <span class="title">Redefinir Senha do representante</span>
    <p-button icon="pi pi-times" class="close-btn" [rounded]="true" [text]="true" (onClick)="cancel()"></p-button>
  </div>

  <form [formGroup]="redefinirSenhaForm" (ngSubmit)="onSubmit()">
    <div class="p-fluid grid">

      <div class="field col-12">
        <label for="email">Email <span class="text-red-500">*</span></label>
        <input id="email" type="email" class="w-full" pInputText formControlName="email" />
        <div *ngIf="redefinirSenhaForm.get('email')?.invalid && redefinirSenhaForm.get('email')?.touched"
          class="error-message">
          Email é obrigatório e deve ser válido
        </div>
      </div>

      <div class="field col-12">
        <label for="username">Nome de usuário <span class="text-red-500">*</span></label>
        <input id="username" type="text" class="w-full" pInputText formControlName="username" />
        <div *ngIf="redefinirSenhaForm.get('username')?.invalid && redefinirSenhaForm.get('username')?.touched"
          class="error-message">
          Username é obrigatório
        </div>
      </div>

      <div class="field col-6 d-flex flex-column">
        <label for="novasenha">Nova senha <span class="text-red-500">*</span></label>
        <p-password id="novasenha" class="w-full" formControlName="novasenha" placeholder="Digite a nova senha"
          type="password" [feedback]="false" [toggleMask]="true"></p-password>
        <div *ngIf="redefinirSenhaForm.get('novasenha')?.invalid && redefinirSenhaForm.get('novasenha')?.touched"
          class="error-message">
          Senha é obrigatória
        </div>
        <div *ngIf="redefinirSenhaForm.get('novasenha')?.errors?.['minlength']" class="error-message">
          A senha deve ter no mínimo 6 caracteres.
        </div>
      </div>

      <!-- Confirmar Senha -->
      <div class="field col-6 d-flex flex-column">
        <label for="confirmarSenha">Confirmar senha <span class="text-red-500">*</span></label>
        <p-password id="confirmarSenha" class="w-full" formControlName="confirmarSenha" type="password"
          placeholder="Digite novamente a nova senha" [feedback]="false" [toggleMask]="true"></p-password>
        <div
          *ngIf="redefinirSenhaForm.get('confirmarSenha')?.touched && redefinirSenhaForm.get('confirmarSenha')?.invalid"
          class="error-message">
          <div *ngIf="redefinirSenhaForm.get('confirmarSenha')?.errors?.['required']">
            Confirmação de senha é obrigatória
          </div>
          <div *ngIf="redefinirSenhaForm.errors?.['senhaMismatch']" class="error-message">
            As senhas não coincidem
          </div>
        </div>
      </div>

    </div>

    <div class="modal-footer" style="margin-top: -10px !important;">
      <button pButton type="button" label="Cancelar" class="p-button-outlined" (click)="cancel()"></button>
      <button pButton type="submit" label="Redefinir Senha" class="p-button-primary"></button>
    </div>
  </form>

</div>

<p-toast appendTo="body"></p-toast>